import api from './api';
import types from './mutation-types';

export default {
	getPlants_({ commit }) {
		return api
			.getPlants()
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: 'plants',
				// 		value: data !== null && data !== undefined ? data.body : null
				// 	});
				// }

				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'plants',
						value: data !== null && data !== undefined ? data.body : null
					});

					commit(types.SEARCH_PARAM, {
						key: 'plantCd',
						value: data.body.length > 0 ? data.body[0].commCd : ''
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},

	getScreens_({ commit, state }, payload) {
		return api
			.getScreens(payload)
			.then(data => {
				const { header, body } = data;
				const { code, message } = header;
				if (code === 0) {
					commit(types.TREE_LIST, body);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	resetState_({ commit }) {
		commit(types.SEARCH_PARAM, { key: 'groupId', value: null });
		commit(types.SEARCH_PARAM, { key: 'screenId', value: null });
		commit(types.DEFAULT_ASSIGN, { key: 'groups', value: [] });
		commit(types.DEFAULT_ASSIGN, { key: 'menuTree', value: [] });
		commit(types.DEFAULT_ASSIGN, { key: 'groupScreenFuncList', value: [] });
	},
	getGroups_({ commit, state }) {
		return api
			.getGroups(state.searchParams)
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: 'groups',
				// 		value: data !== null && data !== undefined ? data.body.resultList : null
				// 	});
				// }

				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getMenuTree_({ commit, state }) {
		return api
			.getMenus(state.searchParams)
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.TREE_LIST, data !== null && data !== undefined ? data.body.resultList : null);
				// }

				if (data.header.code === 0) {
					commit(types.TREE_LIST, data !== null && data !== undefined ? data.body.resultList : null);
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getGroupScreenFuncList_({ commit, state }) {
		return api
			.getGroupScreenFuncList(state.searchParams)
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: 'groupScreenFuncList',
				// 		value: data !== null && data !== undefined ? data.body.resultList : null
				// 	});
				// }

				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'groupScreenFuncList',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getCommFuncList_({ commit, state }) {
		return api
			.getCommFuncList(state.searchParams)
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: 'commFuncList',
				// 		value: data !== null && data !== undefined ? data.body.resultList : null
				// 	});
				// }

				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'commFuncList',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	postGroupScreenFuncList_({ commit }, param) {
		return api
			.postGroupScreenFuncList(param)
			.then(data => {
				// if (!data.body && data.header.code !== 200) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	return data.header;
				// }
				if (data.header.code === 0) {
					return data.header;
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	postGroupCopy_({ commit }, param) {
		return api
			.postGroupCopy(param)
			.then(data => {
				// if (!data.body && data.header.code !== 200) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	return data.header;
				// }

				if (data.header.code === 0) {
					return data.header;
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
